import { type FC } from "react";

import { type LensCard } from "../../lens-insights/models";
import { truncate } from "../../shared/styles";

import { TopLensPreview } from "./TopLensPreview";
import { LensIcon, LensInfo, LensName, LensStat, NameAndValue, TopLensCardContainer } from "./shared";

interface TopLensCardProps {
    lens: LensCard;
}

export const TopLensCard: FC<TopLensCardProps> = ({ lens }) => {
    return (
        <TopLensCardContainer>
            <TopLensPreview preview={lens.preview} />
            <LensInfo>
                <LensIcon src={lens.icon} />
                <NameAndValue>
                    <LensName className={truncate}>{lens.name}</LensName>
                    {lens.value && <LensStat>{lens.value}</LensStat>}
                </NameAndValue>
            </LensInfo>
        </TopLensCardContainer>
    );
};
